import React from 'react';
import '../Screen.css';
// import bgImg from '../images/login-backgrd.jpeg';
import news from '../images/Mahua_khabar.png';
import Desi from '../images/mahuadesi.png';


const Screen = ({ handleShowContent }) => {
    return (
        <>
            <div className="container">
            <div className="header-text">
                    <h2>Watch as you like</h2>
                </div>
                <div className="profiles">
                    <div className="profile" onClick={() => handleShowContent('News')}>
                        <img src={news} alt="News" />
                        <p style={{fontFamily:'poppins'}}></p>
                    </div>
                    <div className="profile" onClick={() => handleShowContent('Entertainment')}>
                        <img src={Desi} alt="Entertainment" />
                        <p style={{fontFamily:'poppins'}}></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Screen;
